export const bestNumberData = {
  title: 'On which phone number should we contact you for your appointment?',
  imgObj: {
    alt: 'Three people standing up with one holding a laptop',
    src: 'https://media.product.which.co.uk/prod/images/original/74244a169467-step2.jpg',
  },
}
